export const searchForCommonItems = (userPermissions: string[], menuItem: string[]): boolean => userPermissions.some((ai) => menuItem.includes(ai));
